// extracted by mini-css-extract-plugin
export default {"container":"Pay_container__MeUU-","Heading":"Pay_Heading__VrNek","Header":"Pay_Header__yJDEs"};